// extracted by mini-css-extract-plugin
module.exports = {"root":"Label_root__82sSy","labelWrap":"Label_labelWrap__gH6MP"};